import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { McommerceTripDetailCartCancelPurchaseDialogComponent } from 'src/app/components/mcommerce-components/mcommerce-trip-detail-cart-cancel-purchase-dialog/mcommerce-trip-detail-cart-cancel-purchase-dialog.component';

@Component({
  selector: 'app-mcommerce-trip-detail-resume-card',
  templateUrl: './mcommerce-trip-detail-resume-card.component.html',
  styleUrls: ['./mcommerce-trip-detail-resume-card.component.scss']
})
export class McommerceTripDetailResumeCardComponent implements OnInit {

  time = '16:03';
  totalAmount = '52,68€';

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }

  public cancelPurchase() {
    this.dialog.open(McommerceTripDetailCartCancelPurchaseDialogComponent);
  }
}
